const SubmitButton = ({ isLoading, isDone, buttonText }) => {
  
    return (
      <button 
        className="submit-button"
        disabled={isLoading || isDone} 
        type="submit"
      >
        {buttonText}
      </button>
    );
  };
  
  export default SubmitButton;